import {Component, OnInit} from '@angular/core';
import {InfoPageComponent} from '../../shared/components/info-page/info-page.component';
import {ActivatedRoute} from '@angular/router';
import {HouseRulesService} from '../../core/api/house-rules.service';
import {LangService} from '../../core/services/lang.service';
import {HouseRule, HouseRules} from '../../shared/models/house-rules.model';
import {getHouseRules} from '../../shared/models/house-rules.model';
import {Nl2brPipe} from '../../shared/pipes/nl2br.pipe';

@Component({
  selector: 'app-house-rule-detail',
  templateUrl: './house-rule-detail.component.html',
  imports: [InfoPageComponent, Nl2brPipe]
})
export class HouseRuleDetailComponent implements OnInit {
  imageSrc = '';
  imageAlt?: string;
  subtitle?: string;
  text?: string;
  houseRule?: HouseRule;

  constructor(private route: ActivatedRoute,
              private houseRulesService: HouseRulesService,
              private langService: LangService
  ) {
  }

  ngOnInit(): void {
    const ruleId = this.route.snapshot.paramMap.get('id');
    if (ruleId) {
      this.loadHouseRule(parseInt(ruleId));
    }
  }

  private loadHouseRule(id: number) {
    this.houseRulesService.getHouseRules().subscribe({
      next: (houseRules: HouseRules) => {
        const rules = getHouseRules(houseRules);
        this.houseRule = rules.find(rule => rule.id === id);
        if (this.houseRule) {
          this.imageSrc = this.houseRule.picture || '';
          this.imageAlt = this.houseRule.title;
          this.subtitle = this.houseRule.title;
          this.text = this.houseRule.text;
        }
      },
      error: (error) => {
        console.error('Error al obtener la regla:', error);
      }
    });
  }

}
